import { createContext, useState, useContext } from "react";

export const CartContext = createContext();

export function CartProvider({ children }) {
    const [cart, setCart] = useState([]);

    const addToCart = (product) => {
        setCart((prevCart) => {
            const exists = prevCart.find(
                (item) => item.id === product.id && item.image === product.image
            );

            if (exists) {
                return prevCart.map((item) =>
                    item.id === product.id && item.image === product.image
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                );
            } else {
                return [...prevCart, { ...product, quantity: 1 }];
            }
        });
    };

    const removeFromCart = (id, image) => {
        setCart((prevCart) =>
            prevCart.filter((item) => !(item.id === id && item.image === image))
        );
    };

    const updateQuantity = (id, image, quantity) => {
        setCart((prevCart) => {
            if (quantity <= 0) {
                return prevCart.filter(
                    (item) => !(item.id === id && item.image === image)
                );
            }

            return prevCart.map((item) =>
                item.id === id && item.image === image
                    ? { ...item, quantity }
                    : item
            );
        });
    };

    const clearCart = () => setCart([]);

    const cartTotal = cart.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
    );

    const cartCount = cart.reduce(
        (sum, item) => sum + item.quantity,
        0
    );

    return (
        <CartContext.Provider
            value={{
                cart,
                addToCart,
                removeFromCart,
                updateQuantity,
                clearCart,
                cartTotal,
                cartCount,
            }}
        >
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
